//#region import
import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Divider, Grid, Radio, Typography } from '@mui/material';
import { TextBoxItem } from 'components/Input/TextBox';
import { TextAreaItem } from 'components/Input/TextArea';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { useLocation, useNavigate } from 'react-router';
import { FnAxios, FnDialog } from 'utilities/utilities';
import SwitchFormItem from 'components/Input/Switch';
import { BtnBack, BtnBaseButton, BtnSave } from 'components/Button/ButtonAll';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { Save } from '@mui/icons-material';
import { GetMenuPermission } from 'utilities/SystemFunction';
//#endregion

const GroupForm = () => {
    const navigate = useNavigate();
    const onBack = () => navigate("/GroupList");
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [loadingTable, setLoadingTable] = useState(false);
    const location = useLocation();
    const searchParams = location.search;
    const sID = new URLSearchParams(searchParams).get('sID');
    const [arrUserRole, setarrUserRole] = useState<any>([]);
    const [lstSelected, setlstSelected] = useState<any>([]);
    const [isButtonShow, setisButtonShow] = useState(false);
    const [lstData, setLstData] = useState([]);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });

    const form = useForm({
        shouldFocusError: true,
        mode: "all"
    });


    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);
    const onSubmit = (e) => {
        let param = {
            sID: sID ?? "",
            nRoleID: form.getValues("sRoleID") ?? 0,
            sGroupName: form.getValues("sGroupName") ?? "",
            sDrescription: form.getValues("sDrescription") ?? "",
            lstPermission: dataRow.arrRows,
            isActive: form.getValues("isActive"),
            sLocation: location.pathname
        };

        DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(`Group/SaveUserGroup`, param, (result) => {
                DialogFn.UnBlockUI();
                DialogFn.Success(`บันทึกสำเร็จ`);
                DialogFn.CloseSubmit()
                navigate(`/GroupList`);
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });

    };

    const GetDataTable = (sRoleID) => {
        let lstChang = (lstSelected.arrRows ?? []);
        lstSelected.forEach((item) => {
            let objData = {
                isDisable: item.isDisable,
                isReadOnly: item.isReadOnly,
                isEnable: item.isEnable,
                sID: item.sID
            };
            lstChang.push(objData)
        })

        let param = {
            sRoleID: sRoleID + "",
            lstSelected: lstChang
        };

        setLoadingTable(true);
        AxiosFn.Post(`Group/GetMenuRole`, param, (result) => {
            setLoadingTable(false);
            setLstData(result.lstPermission || [])
            setDataRow({
                ...dataRow,
                arrRows: result.lstPermission ?? [],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        )
    };

    const GetGroupRoleEdit = () => {
        let param = {
            sID: sID ?? ""
        };
        setLoadingTable(true);
        AxiosFn.Post(`Group/GetGroupRoleEdit`, param, (result) => {
            if (sID) {
                form.setValue("sGroupName", result.sGroupName)
                form.setValue("sRoleID", result.nRoleID)
                form.setValue("sDrescription", result.sDrescription)
                form.setValue("isActive", result.isActive)
                setisButtonShow(result.isShowButton)
            }
            setLoadingTable(false);
            setLstData(result.lstPermission || [])
            setDataRow({
                ...dataRow,
                arrRows: result.lstPermission ?? [],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });

        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        );
    };



    const getFormInitial = () => {
        AxiosFn.Get(`Group/getFormInitial`, {}, (result) => {
            setarrUserRole(result.lstDataPerm);
        })
    }

    const dataColumn: any = [
        {
            field: "sNo",
            headerName: "ลำดับ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 60,
            disableColumnMenu: true,
            renderCell: (item) => {
                return (
                    <>
                        {item.row.nLevel == 1 &&
                            <Typography sx={{ fontWeight: 500, fontSize: 15 }}>{item.row.sNo} </Typography>
                        }
                        {item.row.nLevel == 2 &&
                            <Typography sx={{ fontSize: 15 }}>{item.row.sNo} </Typography>
                        }
                    </>
                )
            }
        },
        {
            field: "sMenuName",
            headerName: "เมนู / ฟังก์ชัน",
            headerAlign: "center",
            align: "Left",
            sortable: false,
            flex: 1,
            width: 250,
            disableColumnMenu: true,
            renderCell: (item) => {
                return (
                    <>
                        {item.row.nLevel == 1 &&
                            <Typography sx={{ fontWeight: 500, fontSize: 15 }}>{item.row.sMenuName} </Typography>
                        }
                        {item.row.nLevel == 2 &&
                            <Typography sx={{ fontSize: 15 }}>{item.row.sMenuName} </Typography>
                        }
                    </>
                )
            }
        },

        {
            field: "isDisable",
            headerName: `ปิดการมองเห็น`,
            headerAlign: "center",
            align: "center",
            resizable: false,
            sortable: false,
            minWidth: 200,
            disableColumnMenu: true,
            renderCell: (item) => {
                if (item.row.isDisableMenu) {
                    return (
                        <Radio checked={item.value} disabled={item.row.isDisableChk || !isPermission} onChange={() => handleChangeRadio(item.row.sID, "isDisable")} />
                    )
                }
                else {
                    return <></>
                }

            }
        },
        {
            field: "isReadOnly",
            headerName: `เฉพาะการเข้าดู`,
            headerAlign: "center",
            align: "center",
            resizable: false,
            sortable: false,
            minWidth: 200,
            disableColumnMenu: true,
            renderCell: (item) => {
                if (item.row.isView) {
                    return (
                        <Radio checked={item.value} disabled={item.row.isReadOnlyChk || !isPermission} onChange={() => handleChangeRadio(item.row.sID, "isReadOnly")} />
                    )
                }
                else {
                    return <></>
                }
            }
        },
        {
            field: "isEnable",
            headerName: `เพิ่ม / แก้ไข / ลบ`,
            headerAlign: "center",
            align: "center",
            resizable: false,
            sortable: false,
            minWidth: 200,
            disableColumnMenu: true,
            renderCell: (item) => {
                if (item.row.isManage) {
                    return (
                        <Radio checked={item.value} disabled={item.row.isEnableChk || !isPermission} onChange={() => handleChangeRadio(item.row.sID, "isEnable",)} />
                    )
                }
                else {
                    return (
                        <Grid item xs={12} md={12} container spacing={1} justifyItems={'end'} justifyContent={'end'} style={{ margin: '5%', color: 'aliceblue' }}>.</Grid>
                    )
                }
            }
        }
    ];



    useEffect(() => {
        getFormInitial();
        if (sID != "") {
            form.setValue("isActive", true);
            GetGroupRoleEdit();
        }
    }, [])

    const handleChangeRadio = (sID, sField) => {
        let latdata = dataRow.arrRows;
        let oCheck = latdata.find((f) => f.sID === sID);
        if (oCheck) {
            oCheck.isDisable = sField === "isDisable";
            oCheck.isReadOnly = sField === "isReadOnly";
            oCheck.isEnable = sField === "isEnable";
            oCheck.isChang = true
        }


        let lstRow = lstSelected.filter(f => f.sID == sID)
        if (lstRow != null && lstRow.length > 0) {
            let Check = (lstRow[0].arrRows ?? []).find((f) => f.sID === sID);
            if (Check) {
                Check.isDisable = sField === "isDisable";
                Check.isReadOnly = sField === "isReadOnly";
                Check.isEnable = sField === "isEnable";

            }
        }
        else {
            let Check = [] as any;
            Check.isDisable = sField === "isDisable";
            Check.isReadOnly = sField === "isReadOnly";
            Check.isEnable = sField === "isEnable";
            Check.sID = sID
            setlstSelected([...lstSelected, Check]);
        }
        setDataRow({
            ...dataRow,
            arrRows: latdata ?? [],
            nDataLength: latdata.length,
        });
    };

    return (
        <React.Fragment>
            <FormProvider {...form}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <SelectItem
                            id="sRoleID"
                            name={"sRoleID"}
                            label={"ประเภทผู้มีสิทธิ์ใช้งานระบบ"}
                            placeholder={"ประเภทผู้มีสิทธิ์ใช้งานระบบ"}
                            options={arrUserRole}
                            required={true}
                            onChange={(v) => {
                                GetDataTable(v ? v.value : null);
                            }}
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <TextBoxItem
                            name="sGroupName"
                            label='ชื่อกลุ่มผู้ใช้งาน'
                            maxLength={150}
                            id={"sName"}
                            required={true}
                            type={'text'}
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <TextAreaItem
                            placeholder=""
                            label='รายละเอียด'
                            name="sDrescription"
                            maxLength={1000}
                            id={"sDescription"}
                            required={false}
                            disabled={!isPermission}
                        />
                    </Grid>
                    {lstData.length > 0 &&
                        <Grid item xs={12} md={12}>
                            <Typography>
                                กำหนดสิทธิ์การใช้งาน
                                <span style={{ color: "red" }}> * </span>
                            </Typography>
                            <Divider />
                        </Grid>
                    }
                    {lstData.length > 0 &&
                        <Grid item xs={12} md={12}>
                            <DataGrid
                                isLoading={loadingTable}
                                columns={dataColumn}
                                rows={dataRow}
                                isHiddenToolHead={true}
                                isHiddenFooter={true}
                                isShowCheckBox={false}
                            />
                        </Grid>
                    }
                    <Grid item xs={12} md={12}>
                        <Typography>
                            สถานะ
                            <span style={{ color: "red" }}> * </span>
                        </Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <SwitchFormItem
                            name={"isActive"}
                            checkText='ใช้งาน'
                            uncheckText='ไม่ใช้งาน'
                            disabled={!isPermission}
                            width={130}
                            id={"isActive"}
                        />
                    </Grid>
                </Grid>

                <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
                    <Grid item xs={6} md={6}>
                        <BtnBack id={"btnBack"} onClick={() => onBack()} />
                    </Grid>

                    <Grid container item xs={6} md={6} justifyContent="flex-end">
                        <BtnSave
                            IsDisabled={!isPermission}
                            id={"btnSave"}
                            onClick={form.handleSubmit(
                                (e) => onSubmit(e),
                                (err) => console.log("err", err)
                            )}
                        />
                    </Grid>
                </Grid>

            </FormProvider>
        </React.Fragment >
    )
}


export default GroupForm;

export const enum EnumPermission {
    Disable = 0,
    ReadOnly = 1,
    Enable = 2,
}

